import parse from 'html-react-parser';
import React, { useEffect, useState, memo } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useStaticPagesMutation } from 'services';
import useLocalizationStore from 'store/localization';
import { getStaticPages } from 'utils';
import useTranslate from 'hooks/useTranslate';
import '../styles.scss';

interface StaticPageData {
	title: string;
	description: string;
}

const StaticPageMobile: React.FC = memo(() => {
	const { activeLanguage } = useLocalizationStore((state) => state);
	const { slug = '' } = useParams<{ slug: string }>();
	const { mutateAsync: staticPagesMutation } = useStaticPagesMutation();
	const [staticData, setStaticData] = useState<StaticPageData | null>(null);
	const [error, setError] = useState<string | null>(null);
	const { translate } = useTranslate();

	useEffect(() => {
		let mounted = true;

		const fetchStaticData = async () => {
			if (!activeLanguage || !mounted) return;

			try {
				const res = await staticPagesMutation();
				if (res.status && mounted) {
					const staticData = getStaticPages(res.data, slug);
					setStaticData(staticData);
				}
			} catch (error) {
				if (mounted) {
					console.error('Failed to fetch static pages:', error);
					setError('Failed to load content');
				}
			}
		};

		fetchStaticData();

		return () => {
			mounted = false;
		};
	}, [activeLanguage, slug, staticPagesMutation]);

	return (
		<section className="static-page bg-white">
			<div className="static-page-banner" style={{ minHeight: '150px' }}>
				<div
					className="static-page-banner-bg h-100 w-100 d-flex align-items-center justify-content-center position-relative"
					style={{ backgroundColor: '#333' }} // Fallback background
				>
					<div className="static-page-banner-bg-overlay w-100 h-100 position-absolute top-0 left-0" />
					<h2 className="fw-bold text-white mb-0 text-center" style={{ fontSize: '1.5rem' }}>
						{staticData?.title || translate('Common.loading')}
					</h2>
				</div>
			</div>
			<Container fluid className="px-3">
				<div className="static-page-content py-4">
					<div className="inner-page-content-box">
						{error ? (
							<p className="text-danger text-center">{error}</p>
						) : staticData?.description ? (
							parse(staticData.description.replace(/\n/g, '<br>'))
						) : (
							<p className="text-muted text-center">{translate('Common.loading')}</p>
						)}
					</div>
				</div>
			</Container>
		</section>
	);
});

export default StaticPageMobile;
